import { useMutation, useQueryClient } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { teamsQueryKeys } from "./queryKeyFactory";
import type { UpdateTeamRequest } from "../types/teams.types";

type UpdateTeamMutationPayload = UpdateTeamRequest & {
    teamId: number;
};

export const useUpdateTeamMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, UpdateTeamMutationPayload>({
        mutationFn: ({ teamId, ...payload }) => salesApiService.teams.updateTeam(teamId, payload),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: teamsQueryKeys.all(), exact: true });
        },
    });
};
